module.exports = __webpack_public_path__ + "static/no-wifi-e88b08b388a437631ea0a920f3115904.png";